<template>

    <v-container style="font-size:14px;margin:20px;">
        <!--<v-row>
            <v-col>
                <div style="margin-top:40px;">
                    Click on an Onkopus module to get to the API reference:
                </div>
            </v-col>
        </v-row>-->
        <!--<v-row align="center" justify="center">
                <v-col cols="12" md="12" lg="3" xl="3" align="center" justify="center" style="height:40px;border:1px solid #e6e6e6;background-color:#f5f5f5;margin:auto;">
                        <a @click="const apiOnkopusServer=ref(); apiOnkopusServer.value.scrollIntoView({ behavior: 'smooth' });" style="text-decoration:None;color:#000000;">
                            Onkopus Server
                        </a>
                </v-col>
                <v-col align="center" justify="center" cols="12" md="12" lg="3" xl="3" style="height:40px;border:1px solid #e6e6e6;background-color:#f5f5f5;margin:auto;">
                    <div style="height:120px;">
                        <a v-bind:href="getURL('dbsnp')" style="text-decoration:None;color:#000000;">
                            Allele population frequency
                        </a>
                    </div>
                </v-col>
                <v-col align="center" justify="center" cols="12" md="12" lg="3" xl="3"  style="height:40px;border:1px solid #e6e6e6;background-color:#f5f5f5;margin:auto;">
                    <div style="height:120px;">
                        <a v-bind:href="getURL('clinvar')" style="text-decoration:None;color:#000000;">
                            ClinVar
                        </a>
                    </div>
                </v-col>
        </v-row>-->
        <v-row>
            <v-col>
                <div>
                    <div id="swagger-ui" ref="swagger"></div>
                    <!--<ApiReference ref="apiOnkopusServer" :configuration="{ spec: { url: swagger_url } }" />-->
                </div>
            </v-col>
        </v-row>
    </v-container>

</template>

<script setup>
import { store } from '@/store'
import axios from 'axios';

//import { ref } from 'vue'



function scrollTo(Refname) {
  window[Refname] = ref()
  //eval('const ' + Refname + '= ' + ref(null))
  //const Refname = ref(null)
  Refname.value.scrollIntoView({ behavior: 'smooth' })
}

function getURL(module) {

    var module_dc = {
        "onkopus-server": "/onkopus-server/v1/doc",
        "dbsnp": "/dbsnp/v1/doc",
        "clinvar": "/clinvar/v1/doc"
    }

    var base_path = store.getters.getEnvVariable("module_server_protocol") + "://" + store.getters.getEnvVariable("module_server") + store.getters.getEnvVariable("module_server_port")
    var module_path = module_dc[module]
    return base_path + module_path
}

import 'swagger-ui-dist/swagger-ui.css';
import { ref, onMounted } from 'vue';

const swaggerRef = ref(null);

const swagger_url = store.getters.getPathVariable("methods_get_os_swagger_endpoint")
import SwaggerUI from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';

//import { ApiReference } from '@scalar/api-reference'

onMounted(async () => {

        SwaggerUI({
            url: swagger_url,
            dom_id: '#swagger-ui'
        })
});

</script>
<style>
.selectable {
  user-select: text !important;
}

/* This applies the fix globally if the issue affects the whole app */
* {
  user-select: text !important;
}
</style>